//document.querySelector('body').classList.add('body-fade');

// Custom JS
//window.onload = function() {
//  document.querySelector('body').classList.add('body-fade');
//};

//document.addEventListener("DOMContentLoaded", function(event) {
//  document.querySelector('body').classList.add('body-fade');
//});

const element = document.getElementById("locksmith-content");
if (element) {
    document.body.classList.remove("light-header");
}

theme.checkOverflow = (function() {
  function meganav() {
    var banner = document.querySelector(".announcement-bar");
    var target = document.querySelectorAll(".site-nav__link");
    var underlay = document.querySelector(".drawer-page-content");
    var header = document.querySelector(".site-header__secondary-row"); // Get the header element
    var i;

    for (i = 0; i < target.length; i++) {
      let timeout;

      target[i].addEventListener("mouseover", function () {
        const el = this;
        timeout = setTimeout(function () {
          var attr = el.getAttribute('meganav-id');
          var meganav = document.getElementById('meganav-' + attr);
          var divsToHide = document.getElementsByClassName("meganav");
          var d = document.getElementsByClassName("site-nav__link");

          for (var j = 0; j < divsToHide.length; j++) {
            divsToHide[j].classList.remove("is-visible");
          }

          for (var j = 0; j < d.length; j++) {
            d[j].classList.remove("active-link");
          }

          el.classList.add("active-link");
          underlay.classList.remove("meganav-is-visible");

          if (typeof meganav !== 'undefined' && meganav !== null) {
            meganav.classList.add("is-visible");

            // Add class to the header when meganav is open
            if (meganav.classList.contains('is-visible')) {
              underlay.classList.add("meganav-is-visible");
              if (header) {
                header.classList.add("meganav-open"); // Add the class to header
              }
            }
          }
        }, 400); // delay in ms (adjust to your liking)
      });

      target[i].addEventListener("mouseout", function () {
        clearTimeout(timeout);
      });
    }

    underlay.addEventListener("mouseover", hideMeganav);

    function hideMeganav() {
      var underlay = document.querySelector(".drawer-page-content");
      var divsToHide = document.getElementsByClassName("meganav");
      var d = document.getElementsByClassName("site-nav__link");

      for (var i = 0; i < divsToHide.length; i++) {
        divsToHide[i].classList.remove("is-visible");
      }

      for (var i = 0; i < d.length; i++) {
        d[i].classList.remove("active-link");
      }

      this.classList.remove("meganav-is-visible");
      underlay.classList.remove("meganav-is-visible");

      // Remove class from the header when meganav is closed
      if (header) {
        header.classList.remove("meganav-open"); // Remove the class from header
      }
    }
  }

  function checkOverflow() {
    var header = document.querySelector('.site-header');
    var nav = document.querySelector('.site-nav');
    var container = document.querySelector("body");

    if (window.innerWidth > 1024) {
      if (nav.offsetWidth > header.offsetWidth) {
        container.classList.add("is-overflowing");

        var underlay = document.querySelector(".drawer-page-content");
        var divsToHide = document.getElementsByClassName("meganav");
        var d = document.getElementsByClassName("site-nav__link");

        for (var i = 0; i < divsToHide.length; i++) {
          divsToHide[i].classList.remove("is-visible");
        }

        for (var i = 0; i < d.length; i++) {
          d[i].classList.remove("active-link");
        }

        underlay.classList.remove("meganav-is-visible");
      } else {
        container.classList.remove("is-overflowing");
        meganav();
      }
    }
  }


  // Meganav link hover
  var link = document.querySelectorAll(".meganav-column ul li");
  var i;

  for (i = 0; i < link.length; i++) {
    link[i].addEventListener("mouseover", activate, false);
    link[i].addEventListener("mouseout", deactivate, false);

    function activate() {
      for (let sibling of this.parentNode.children) {
        if (sibling !== this) {
          sibling.classList.add('sibling');
        } else {
          sibling.classList.remove('sibling');
        }
      }
    }

    function deactivate() {
      for (let sibling of this.parentNode.children) {
        sibling.classList.remove('sibling');
      }
    }
  };

  document.addEventListener("DOMContentLoaded", checkOverflow);
  window.addEventListener("resize", checkOverflow);
})();

theme.triggerLiveChat = (function() {
  var open = document.querySelector(".livechat-trigger__open");
  var close = document.querySelector(".livechat-trigger__close");

  open.addEventListener("click", showLiveChat);
  close.addEventListener("click", hideLiveChat);
  
  function showLiveChat() {
    open.classList.add('hide-btn');
    close.classList.remove('hide-btn');
    GorgiasChat.open();
  }

  function hideLiveChat() {
    open.classList.remove('hide-btn');
    close.classList.add('hide-btn');
    GorgiasChat.close();
  }
})();

theme.animateElement = (function() {
	// Animations on scroll start
	const elements = document.querySelectorAll(".animate-block, .animate-text, .animate-img")

	// fade out on load
	elements.forEach(element => {
	  element.style.opacity = 0.5
	})

	const fadeIn = function () {
	  // look through all the animated tags and see
	  // with the getBoundingClientRect if it's in the window
	  let delay = 0

	  elements.forEach(element => {
	    const positionFromTop = element.getBoundingClientRect().top
	    const positionFromBottom = element.getBoundingClientRect().bottom

	    if (positionFromTop < window.innerHeight && positionFromBottom > 0) {
	      element.style.animation = `fadein 1s ease-in-out ${delay}s both`
	      delay = delay + 0.2
	    }
	  })
	}

	// on load, run fadeIn
	fadeIn();

	// on scroll, run fadeIn
	window.addEventListener("scroll", fadeIn);

	// on browser resize, run fadeIn
	window.addEventListener("resize", fadeIn);
	// Animations on scroll end
})();

theme.scrollingHeader = (function() {
	var header = document.querySelector('.site-header__secondary-row');

  if (!header) {return}

	window.addEventListener('scroll', function() {
		var fromTop = window.pageYOffset;
		if (fromTop > 0) {
			header.classList.add("is-scrolling");
      document.querySelector('body').classList.add('mob-header-is-scrolling');
		} else {
			header.classList.remove("is-scrolling");
      document.querySelector('body').classList.remove('mob-header-is-scrolling');
		}
	});
})();

theme.checkFormField = (function() {
  const isEmpty = str => !str.trim().length;
  const field = document.querySelectorAll('.field__input-wrapper input');
  const cfField = document.querySelectorAll('.cf-field');

  field.forEach(function(i) { 
    i.addEventListener("input", function() {
      if( isEmpty(this.value) ) {
        this.classList.remove('active');
      } else {
        this.classList.add('active');
      }
    });
  });

  cfField.forEach(function(i) { 
    i.addEventListener("input", function() {
      if( isEmpty(this.value) ) {
        alert('active');
        this.classList.remove('active');
      } else {
        alert('not active');
        this.classList.add('active');
      }
    });
  });
})();

theme.anchorSmoothScroll = (function() {
	const links = document.querySelectorAll("a[href^='#'] ");
  
	for (const link of links) {
	  link.addEventListener("click", clickHandler);
	}

	function clickHandler(e) {
	  e.preventDefault();
	  const href = this.getAttribute("href");
	  const offsetTop = document.querySelector(href).offsetTop;
    const prodPage = document.querySelector('.template-product');

    if (typeof(prodPage) != 'undefined' && prodPage != null) {
      var minusAmount = 100; //170
    } else {
      var minusAmount = 0;
    }

	  scroll({
	    top: offsetTop - minusAmount, 
	    behavior: "smooth"
	  });
	}
})();

theme.drawers = (function() { 
  var toggle = document.querySelectorAll('.open-drawer');

  toggle.forEach(function(el) {    
    var id = el.getAttribute('data-id');
    var drawer = document.getElementById('drawer--' + id);
    var container = document.querySelector("body");

    if(typeof(drawer) != 'undefined' && drawer != null){
      el.addEventListener("click", showDrawer);
      document.querySelectorAll(".close-drawer").forEach(close => { close.addEventListener("click", hideDrawer); });

      function showDrawer() {
        document.querySelectorAll(".drawer").forEach(drawer => { drawer.classList.remove("this-drawer-is-open"); });
        drawer.classList.add("this-drawer-is-open");
        container.classList.add("a-drawer-is-open");

        document.querySelector(".customer-login-drawer__inner-container").classList.remove('hide');
      }
      
      function hideDrawer() {
        drawer.classList.remove("this-drawer-is-open");
        container.classList.remove("a-drawer-is-open");

        document.querySelector(".customer-login-drawer__inner-container").classList.add('hide');
      }
    }
  });
})();

theme.accordion = (function() {
	function initAcc(elem, option){
    document.addEventListener('click', function (e) {
        if (!e.target.matches(elem+' .accordion-toggle')) return;
        else{
            if(!e.target.parentElement.classList.contains('active')){
                if(option==true){
                    var elementList = document.querySelectorAll(elem+' .accordion__container');
                    Array.prototype.forEach.call(elementList, function (e) {
                        e.classList.remove('active');
                    });
                }
                e.target.parentElement.classList.add('active');
            }else{
                e.target.parentElement.classList.remove('active');
            }
        }
    });
	}

	initAcc('.accordion-wrapper', true);
})();

theme.tableAccordion = (function() {
  document.querySelectorAll('.accordion-table tr td:first-child').forEach(element => element.classList.add('accordion-table-toggle'))
  document.querySelectorAll('.accordion-table tr td:last-child').forEach(element => element.classList.add('accordion-table-panel'))

  var acc = document.getElementsByClassName("accordion-table-toggle");
  var i;

  function accordionLoad() {
    for (i = 0; i < acc.length; i++) {
      if (i == 0) {
        acc[i].classList.toggle("active");
        var panel = acc[i].nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
        console.log('Scroll Height:' + panel.scrollHeight);
      }

      acc[i].addEventListener("click", function(ev) {
        closeAll(ev.target);
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          console.log('Scroll Height:' + panel.scrollHeight);
        }
      });
    }
  }

  window.addEventListener("load", accordionLoad);

  function closeAll(tar) {
    var accs = document.querySelectorAll('.accordion-table-toggle');
    for (var i = 0; i < accs.length; i++) {
      if (accs[i] == tar) {
        continue;
      }
      accs[i].classList.remove('active');
      var panel = accs[i].nextElementSibling;
      panel.style.maxHeight = null;
    }
  }

  return {
    init: function() {
      accordionLoad();
    }
  };
})();

theme.productSwatches = (function() {
  function init() {
    var swatch = document.querySelectorAll('.variant-swatch');

    swatch.forEach(function(el) {
      el.addEventListener("click", updateSwatch);

      function updateSwatch() {
        var parent = el.closest(".selector-wrapper");
        var newColor = el.getAttribute('data-id');
        var label = parent.querySelector('.selector-wrapper_name span');

        label.innerHTML = newColor;
      }
    });
  }

  return init();
})();

theme.productQuantity = (function() {
  var body = document.querySelector('body');
  
  if(body.classList.contains('template-product')){
    var qtyIncrement = document.querySelectorAll('.js--quantity');

    qtyIncrement.forEach(function(el) { 
      el.addEventListener("click", updateQty);

      function updateQty(el) {
        var parent = this.closest(".quantity-wrapper"),
            input = parent.querySelector('input'),
            inputVal = parseInt(input.value),
            sendQuantity = 0,
            incrementBoolean = this.getAttribute('data-increment'),
            increment = incrementBoolean.toString();

        if (increment == 'true') {
          var newVal = inputVal+1;
          input.value = newVal;
          console.log('up 1');
        } else {
          if (inputVal-1 != 0) {
            var newVal = inputVal-1;
            input.value = newVal;
            console.log('down 1');
          }
        }   
      }
    });
  }

  if(body.classList.contains('product-wallpaper')){
    var qtyIncrement = document.querySelectorAll('.js--quantity__in-yards');

    qtyIncrement.forEach(function(el) { 
      el.addEventListener("click", updateWallQty);

      function updateWallQty(el) {
        var parent = this.closest(".quantity-wrapper__wallpaper"),
            input = parent.querySelector('input'),
            inputVal = parseInt(input.value),
            incrementBoolean = this.getAttribute('data-increment'),
            increment = incrementBoolean.toString();

        if (increment == 'true') {
          var newVal = inputVal+1;
          input.value = newVal;
          //console.log('up 1');
        } else {
          if (inputVal-1 > 4) {
            var newVal = inputVal-1;
            input.value = newVal;
            //console.log('down 1');
          }
        }
      }    
    });
  }
})();

theme.productAvailability = (function() {
  var availability = document.getElementById('inventoryLocationInformation');
  var btn = document.querySelector('.store-info-btn');
  var container = document.querySelector('.inventoryLocationInformation-wrapper');
  
  if(typeof(availability) != 'undefined' && availability != null) {
    var toggleBtn = document.querySelector('.inventoryLocationInformation-toggle');
    toggleBtn.addEventListener("click", toggle);

    function toggle() {
      btn.classList.remove('hide');
      container.classList.toggle('expanded');

      if (container.classList.contains('expanded')) {
        toggleBtn.innerHTML = 'Close';
        container.style.maxHeight = "500px";
      } else {
        toggleBtn.innerHTML = 'View store availability';
        container.style.maxHeight = "65px";
      }
    }
  }
})();

window.addEventListener("load", theme.productAvailability);

/*theme.productTerms = (function() {
  var label = document.querySelector('.terms-msg');

  if(typeof(label) != 'undefined' && label != null){
    label.addEventListener("click", checkInput);
    checkInput();

    function checkInput() {
      var checkbox = document.getElementById('product-terms'),
          button = document.querySelector('.product-form__cart-submit');

      if (checkbox.checked) {
        // Checked
        button.disabled = false;
        document.querySelector('[data-mulberry-custom-btn]').removeAttribute('disabled')
        document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', 'margin-bottom: 10px; color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
        if (typeof mulberry !== undefined) {
         if (window.variantsWithWarranties && window.offers.length !== 0) {
           if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
              $(mulberrySelectors.protectionAddedBtn).hide()
              $(mulberrySelectors.customMulberryBtn).show()
             } else {
               $(mulberrySelectors.protectionAddedBtn).show()
               $(mulberrySelectors.customMulberryBtn).hide()
             }
          }
          else {
       	$('[data-mulberry-custom-btn]').hide()
        }
        } else {
        	$('[data-mulberry-custom-btn]').hide()
        }
      } else {
        // Not checked
        button.disabled = true;
        document.querySelector('[data-mulberry-custom-btn]').setAttribute('disabled', true)
        document.querySelector('[data-mulberry-custom-btn]').removeAttribute('style', 'color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
        document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', "margin-bottom: 10px;")
        if (typeof mulberry !== undefined) {
          if (window.variantsWithWarranties && window.offers.length !== 0) {
           if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
            $(mulberrySelectors.protectionAddedBtn).hide()
            $(mulberrySelectors.customMulberryBtn).show()
           } else {
             $(mulberrySelectors.protectionAddedBtn).show()
             $(mulberrySelectors.customMulberryBtn).hide()
           }
          }
          else {
       	$('[data-mulberry-custom-btn]').hide()
        }
        } else {
       	$('[data-mulberry-custom-btn]').hide()
        }
      }
    }
  }
})();*/

theme.productTerms = (function() {
  var label = document.querySelector('.terms-msg');

  if (label) {
      label.addEventListener("click", checkInput);
  }

  document.addEventListener('offers-received', async function() {
    console.log('EVENT FOUND')
    if (window.location.href.indexOf('/products') !== -1) {
      setTimeout(() => {
        checkInput();
      }, 0)
    }
  })

  async function checkInput() {
      var checkbox = document.getElementById('product-terms'),
          button = document.querySelector('.product-form__cart-submit');

      if ((checkbox && checkbox.checked) || !checkbox) {
          // Checked
          button.disabled = false;
          document.querySelector('[data-mulberry-custom-btn]').removeAttribute('disabled')
          document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', 'margin-bottom: 10px; color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
          if (typeof mulberry !== undefined) {
              if (window.offers.length !== 0) {
                  if (await findUnlimitedItem()) {
                      document.querySelector('[data-mulberry-custom-btn]').setAttribute('disabled', true)
                      document.querySelector('[data-mulberry-custom-btn]').removeAttribute('style', 'color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
                      document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', "margin-bottom: 10px;")
                      $(mulberrySelectors.customMulberryBtn).hide()
                      $(mulberrySelectors.protectionAddedBtn).show()
                  } else {
                      if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
                          $(mulberrySelectors.protectionAddedBtn).hide()
                          $(mulberrySelectors.customMulberryBtn).show()
                      } else {
                          $(mulberrySelectors.protectionAddedBtn).show()
                          $(mulberrySelectors.customMulberryBtn).hide()
                      }
                  }

              } else {
                  $('[data-mulberry-custom-btn]').hide()
              }
          } else {
            console.log('mulberry', mulberry);
            if(mulberry) {
               $('[data-mulberry-custom-btn]').show()
            } else {
              $('[data-mulberry-custom-btn]').hide()
            }
          }
      } else {
        console.log('not checked');
        console.log('nc', mulberry);
          // Not checked
          button.disabled = true;
          document.querySelector('[data-mulberry-custom-btn]').setAttribute('disabled', true)
          document.querySelector('[data-mulberry-custom-btn]').removeAttribute('style', 'color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
          document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', "margin-bottom: 10px;")
          if (typeof mulberry !== undefined) {
              if (window.offers.length !== 0) {
                  if (await findUnlimitedItem()) {
                      document.querySelector('[data-mulberry-custom-btn]').setAttribute('disabled', true)
                      document.querySelector('[data-mulberry-custom-btn]').removeAttribute('style', 'color:#262D26; background-color:#FBF9F7; border-color:#262D26;')
                      document.querySelector('[data-mulberry-custom-btn]').setAttribute('style', "margin-bottom: 10px;")
                      $(mulberrySelectors.customMulberryBtn).hide()
                      $(mulberrySelectors.protectionAddedBtn).show()
                  } else {
                      if (!window.variantsWithWarranties.includes(mulberryShop.selectedVariantId)) {
                          $(mulberrySelectors.protectionAddedBtn).hide()
                          $(mulberrySelectors.customMulberryBtn).show()
                      } else {
                          $(mulberrySelectors.protectionAddedBtn).show()
                          $(mulberrySelectors.customMulberryBtn).hide()
                      }
                  }
              } else {
                  $('[data-mulberry-custom-btn]').hide()
              }
          } else {
            if(mulberry) {
               $('[data-mulberry-custom-btn]').show()
            } else {
              $('[data-mulberry-custom-btn]').hide()
            }
          }
      }
  }
})();

theme.productMBSNav = (function() {
  var nav = document.querySelector('.mbs__nav');

  if(typeof(nav) != 'undefined' && nav != null){
    const links = document.querySelectorAll('.mbs__nav li');
    const sections = document.querySelectorAll('.mbs-section');

    function changeLinkState() {
      let index = sections.length;

      while(--index && window.scrollY + 100 < sections[index].offsetTop) {}
      
      links.forEach((link) => link.classList.remove('active'));
      links[index].classList.add('active');
    }

    changeLinkState();
    window.addEventListener('scroll', changeLinkState);
  }
})();

theme.expandingElementCart = (function() {
  var exEl = document.querySelector('.expanding-overflow');

  if(typeof(exEl) != 'undefined' && exEl != null){
    var btn = document.querySelector('.expanding-overflow .btn');

    btn.addEventListener("click", toggle);

    function toggle() {
      exEl.classList.toggle('expanded');

      if (exEl.classList.contains('expanded')) {
        btn.innerHTML = 'Minimize basket';
        exEl.style.maxHeight = "3000px";
        btn.classList.add('btn--secondary');
      } else {
        btn.innerHTML = 'View full basket';
        exEl.style.maxHeight = "345px";
        btn.classList.remove('btn--secondary');
      }
    }
  }
})();

theme.expandingElementCollection = (function() {
  var exEl = document.querySelector('.expanding-overflow-collection');

  if(typeof(exEl) != 'undefined' && exEl != null){
    var btn = document.querySelector('.expanding-overflow-collection .btn');
    var pagination = document.querySelector('.pagination-hide');

    btn.addEventListener("click", toggle);

    function toggle() {
      exEl.classList.toggle('expanded');

      if (exEl.classList.contains('expanded')) {
        btn.innerHTML = 'Minimize products';
        exEl.style.maxHeight = "14200px";
        btn.classList.add('btn--secondary');
        setTimeout(function() {
          pagination.classList.add('show');
        }, 2000);
      } else {
        btn.innerHTML = 'View all products';
        exEl.style.maxHeight = "1250px";
        btn.classList.remove('btn--secondary');
        setTimeout(function() {
          pagination.classList.remove('show');
        }, 2000);
      }
    }
  }
})();

theme.cookies = (function() {
  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    //let user = getCookie("username");
    //if (user != "") {
    //  alert("Welcome again " + user);
    //} else {
    //   user = prompt("Please enter your name:","");
    //   if (user != "" && user != null) {
    //     setCookie("username", user, 30);
    //   }
    //}
    
    
    var cartTemplate = document.querySelector('.template-cart');

    if (typeof(cartTemplate) != 'undefined' && cartTemplate != null) {
      let cartModalCookie = getCookie("cartCookie");
      var cartModal = document.querySelector('.cart__backorder-prompt');
      
      if (typeof(cartModal) != 'undefined' && cartModal != null) {
        if (cartModalCookie != "") {
          // Returning visitor
          //alert("Returning visitor:");

          // If the modal doesn't have the class then add class 'hide'.
          if (!cartModal.classList.contains('hide-modal')) {
            cartModal.classList.add('hide-modal');
          }
        } else {
          // New visitor
          //alert("New visitor:");
          var closeModal = document.querySelector('.cart__backorder-prompt svg'); 
          cartModalCookie = 'true';
          
          // Show modal
          setTimeout(function(){ 
            cartModal.classList.remove('hide-modal');
            document.querySelector('body').classList.add('cookie-modal-is-visible');
          }, 2000);

          // Close modal and set cookie
          closeModal.addEventListener("click", function(){
            cartModal.classList.add('hide');
            document.querySelector('body').classList.remove('cookie-modal-is-visible');

            if (cartModalCookie != "" && cartModalCookie != null) {
              // Cookie Name, Cookie Value, No of days until expiry
              setCookie("cartCookie", cartModalCookie, 1);
            }
          });
        }
      }
    }
  }

  checkCookie();
})();

theme.customerAccountCheckoutRedirect = (function() {
  var page = document.querySelector('.page-customer-redirect');

  if(typeof(page) != 'undefined' && page != null){
    var REDIRECT_PATH = '/cart';

    var selector = '#customer_login, #create_customer, form[action$="/account"][method="post"]',
        form = document.querySelectorAll(selector)[0];

    if (form) {
      redirect = document.createElement('input');
      redirect.setAttribute('name', 'return_to');
      redirect.setAttribute('type', 'hidden');
      redirect.value = REDIRECT_PATH;
      form.appendChild(redirect);
    }
  }
})();

theme.videoHasSound = (function() {
  var hasSound = document.querySelectorAll('.has-vid-w-sound');

  if(typeof(hasSound) != 'undefined' && hasSound != null){
    hasSound.forEach(function(i) { 
      var video = i.querySelector('video'),
          mute  = i.querySelector('.icon-mute'),
          sound = i.querySelector('.icon-sound');

      mute.addEventListener("click", toggle);
      sound.addEventListener("click", toggle);

      function toggle() {
        for (let sibling of this.parentNode.children) {
          if (sibling !== this) {
            sibling.style.display = "block";
          } else {
            this.style.display = "none";
          }
        }

        if( video.muted ) {
          video.muted = false;
        } else {
          video.muted = true;
        }
      }
    });
  }
})();

theme.videoIsInViewport = (function() {
  var checkView = document.querySelectorAll('video.play-in-view');

  if(typeof(checkView) != 'undefined' && checkView != null){
    checkView.forEach(function(i) { 
      function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
            rect.bottom >= 100 && // 375
            rect.right >= 100 // 375
        );
      }

      if (isInViewport(i)) {
        console.log('load - is in view');
        i.play();
      } else {
        console.log('load - nope');
        i.pause();
      }

      window.addEventListener('scroll', function () {
        if (isInViewport(i)) {
          console.log('scroll - is in view');
          i.play();
        } else {
          console.log('scroll - nope');
          i.pause();
        }
      }, false);
    });
  }
})();

/*theme.cloneImportantMsg = (function() {
  var a = document.querySelectorAll(".important-msg");

  a.forEach(function(i) { 
    var itm = i;
    var cln = itm.cloneNode(true);
    var appendTo = i.parentNode;
    appendTo.appendChild(cln); 
    i.classList.add('hide');
  });
})();*/

theme.swatchCollectionFilter = (function() {
  if (window.jQuery && $('#collection-swatches').length != 0) {  
   // Get grid/items container. 
   const $gridItems = $('#collection-swatches div.grid--view-items');
   const filterConfig = {
      nOfColumn : 4,
      containerWidth : 100,
      aspectRatio : '5:7',
      responsive : [
         {
              breakpoint : 1600,
              containerWidth : 1560,
              settings : {
                  nOfRow : 3,
                  nOfColumn : 4
              }
          },
         {
              breakpoint : 1400,
              containerWidth : 1360,
              settings : {
                  nOfRow : 2,
                  nOfColumn : 4
              }
          },
          {
              breakpoint : 1200,
              containerWidth : 1160,
              settings : {
                  nOfRow : 2,
                  nOfColumn : 4
              }
          },
          {
              breakpoint : 989,
              containerWidth : 949,
              settings : {
                  nOfRow : 3,
                  nOfColumn : 3
              }
          },
          {
              breakpoint : 768,
              containerWidth : 738,
              settings : {
                  nOfRow : 2,
                  nOfColumn : 2
              }
          }
      ]
    };
    
    $(window).resize(function(){
      $gridItems.filterData(filterConfig);
    });
   
    // Load filter JS.
    $gridItems.filterData(filterConfig);
    
    var sortTags = document.getElementById('SortTags');

    if(typeof(sortTags) != 'undefined' && sortTags != null){
      sortTags.addEventListener("change", function(evt) {
        //var selectedcollection = evt.target.value;
        //filterGoCollection(selectedcollection);
        $('.filter-button-controllers .'+ evt.target.value).click();
      });
    }
  }
})();

const ReadMore = (() => {
   let s;

   return {

     settings() {
       return {
         content: document.querySelectorAll('.js-read-more'),
         originalContentArr: [],
         truncatedContentArr: [],
         moreLink: "Read more",
         lessLink: "Read less",
       }
     },

     init() {
       s = this.settings();
       this.bindEvents();
     },

     bindEvents() {
       ReadMore.truncateText();
     },

     /**
      * Count Words
      * Helper to handle word count.
      * @param {string} str - Target content string.
      */
     countWords(str) {
       return str.split('').length;
     },

     /**
      * Ellpise Content
      * @param {string} str - content string.
      * @param {number} wordsNum - Number of words to show before truncation.
      */
     ellipseContent(str, wordsNum) {
       return str.split('').slice(0, wordsNum).join('') + '...';
     },

     /**
      * Truncate Text
      * Truncate and ellipses contented content
      * based on specified word count.
      * Calls createLink() and handleClick() methods.
      */
     truncateText() {

       for (let i = 0; i < s.content.length; i++) {
         //console.log(s.content)
         const originalContent = s.content[i].innerHTML;
         const numberOfWords = s.content[i].dataset.rmWords;
         const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
         const originalContentWords = ReadMore.countWords(originalContent);

         s.originalContentArr.push(originalContent);
         s.truncatedContentArr.push(truncateContent);

         if (numberOfWords < originalContentWords) {
           s.content[i].innerHTML = s.truncatedContentArr[i];
           let self = i;
           ReadMore.createLink(self)
         }
       }
       ReadMore.handleClick(s.content);
     },

     /**
      * Create Link
      * Creates and Inserts Read More Link
      * @param {number} index - index reference of looped item
      */
     createLink(index) {
       const linkWrap = document.createElement('span');

       linkWrap.className = 'read-more__link-wrap';

       linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

       // Inset created link
       s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

     },

     /**
      * Handle Click
      * Toggle Click eve
      */
     handleClick(el) {
       const readMoreLink = document.querySelectorAll('.read-more__link');

       for (let j = 0, l = readMoreLink.length; j < l; j++) {

         readMoreLink[j].addEventListener('click', function() {

           const moreLinkID = this.getAttribute('id');
           let index = moreLinkID.split('_')[1];

           el[index].classList.toggle('is-expanded');

           if (this.dataset.clicked !== 'true') {
              el[index].innerHTML = s.originalContentArr[index];
              this.innerHTML = s.lessLink;
              this.dataset.clicked = true;
           } else {
             el[index].innerHTML = s.truncatedContentArr[index];
             this.innerHTML = s.moreLink;
             this.dataset.clicked = false;
           }
         });
       }
     },

     /**
      * Open All
      * Method to expand all instances on the page.
      */
     openAll() {
       const instances = document.querySelectorAll('.read-more__link');
         for (let i = 0; i < instances.length; i++) {
           content[i].innerHTML = s.truncatedContentArr[i];
           instances[i].innerHTML = s.moreLink;
         }
       }
     }
 })();

ReadMore.init()

function accessoriesDoneLoadingCallback(div, product) { 
  var item = document.querySelectorAll('.accessories-item');
  var counter = 0;

  item.forEach(function(i) { 
    counter++;

    // element that will be wrapped
    var container = i.querySelector('input');

    // create wrapper container
    var wrapper = document.createElement('label');
    
    wrapper.classList.add('control--checkbox', 'accessory-checkbox');
    wrapper.htmlFor = 'accessory-'+ counter;

    // insert wrapper before el in the DOM tree
    container.parentNode.insertBefore(wrapper, container);
    container.id = 'accessory-'+ counter;

    // move el into wrapper
    wrapper.appendChild(container);
   
    // create custom checkbox
    var checkbox = document.createElement('span');
    checkbox.classList.add('control-indicator');
   
    wrapper.appendChild(checkbox);
  });
}

function accessoriesQuickViewCallback(divModal, product){
  var modal = document.getElementById('accessories-modal');
  var table = modal.querySelector('.accessory-description');

  table.classList.add('accordion-table');
  document.querySelectorAll('.accordion-table tr td:first-child').forEach(element => element.classList.add('accordion-table-toggle'))
  document.querySelectorAll('.accordion-table tr td:last-child').forEach(element => element.classList.add('accordion-table-panel'))

  theme.tableAccordion.init();
}

/**
 * Component: Quick view
 * ------------------------------------------------------------------------------
 * A quick view component.
 *
 */

/**
 * Create a new quick view object.
 */
theme.quickView = (function() {
  /**
   * DOM selectors.
   */
  const selectors = {
    container: '[js-quick-view="container"]',
    mask: '[js-quick-view="mask"]',
    body: '[js-quick-view="body"]',
    toggle: '[js-quick-view="toggle"]',
    close: '[js-quick-view="close"]',
  };

  /**
 * DOM node selectors.
 */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    mask: document.querySelector(selectors.mask),
    body: document.querySelector(selectors.body),
    toggle: document.querySelectorAll(selectors.toggle),
  };

  /**
 * Initialise component.
 */
  function init() {
    if (!nodeSelectors.toggle) {return;}

    setEventListeners();
    console.log(`🏅 Quick View: Loaded`)
  }

  /**
 * Set event listeners.
 */
  function setEventListeners() {
    nodeSelectors.toggle.forEach((item) => {
      item.addEventListener("click", function(event){
        const productHandle = event.target.dataset.quickViewUrl;
        const productType = event.target.dataset.productType;
        const productTarget = event.target;
        handleQuickViewEvent(productHandle, productType, productTarget)
      });
    });

    document.addEventListener('click', function (event) {
      // All click events will be handled by this function, so it needs to be as cheap as possible. To check
      // whether this function should be invoked, we're going to check whether the element that was clicked on
      // was the elemnt that we care about. The element that was clicked on is made available at "e.target"
      const element = event.target;

      // Check if it matches our previously defined selector
      if (element.matches(selectors.close)) {
        closeQuickAdd();
      }

      if (element.matches(selectors.mask)) {
        closeQuickAdd();
      }
    });
  }

  /**
 * Handle QuickAdd modal close.
 */
  function closeQuickAdd() {
    nodeSelectors.container.classList.remove('is-active');
  }

  /**
 * Handle quick view event.
 * @param {String} handle - The product handle to quick view.
 */
  function handleQuickViewEvent(handle, type, productTarget) {
    if(type === 'addToCart') {
      // Create add to cart function here
      newAddToCartFunction(handle, type, productTarget);
    } else {
      nodeSelectors.container.classList.add('is-active');
      setLoadingState();
      toggleQuickView(handle);
    }

    //  TODO: look at updating the container to load this in
  }

  function newAddToCartFunction(handle, type, productTarget) {
    // Simple add to cart functionality should happen here to trigger the add to cart,
    // the ajax cart popup notification and the cart count should update.
    let quickFormButton;
    
    toggleQuickView(handle, getButton);
    console.log(productTarget);
    productTarget.innerHTML = "ADDING...";
    
    function getButton() {
      quickFormButton = document.querySelector(".quick-view__aside .product-form__cart-submit");
      quickFormButton.click();
      const waitForReset = setTimeout(resetText, 1000); 
    }

    function resetText() {
      productTarget.innerHTML = "ADD SAMPLE TO CART";
    }
  }

  /**
   * Toggle quick view modal after fetching data from toggle target.
   * @param {String} handle - The product handle to quick view.
   */
  function toggleQuickView(handle, noPreview) {

    fetch(getProductUrl(handle))
      .then(res => {
        return res.text();
      })
      .then(data => {
        if(noPreview) {
          data = data.replace("id=\"shopify-section-product-quick-view\"", "id=\"shopify-section-product-quick-view\" style=\"display:none\"");
        }

        nodeSelectors.body.innerHTML = data;
        removeLoadingState();

        const container = document.querySelector('.product-template__container');
        const p = new theme.Product(container);
      })
      .then( function() {
        addDynamicListeners(handle);
        quantity();
        noPreview();
      })
      .catch((error) => error);
  }

  function addDynamicListeners(handle) {
    const container = document.querySelector('.product-template__container');
    const select = container.querySelectorAll('.single-option-selector');

    select.forEach((item) => {
      item.addEventListener("change", function(event){
        updateImage(handle)
      });
    });
  }

  function updateImage(handle) {
    const select = document.querySelector('.product-form__variants');
    const selectVal = parseInt(select.value);
    const productJson = JSON.parse(document.getElementById('ProductJson-product-quick-view').textContent);
    const variants = productJson.variants;

    variants.forEach((item) => {
      if(item.id === selectVal) {
        if(item.hasOwnProperty('featured_image') != null && item.featured_image != null) {
          if(item.featured_image.hasOwnProperty('src') != null) {
            const imageClass = document.querySelector('.js-image-' + handle);
            imageClass.src = item.featured_image.src;
            imageClass.srcset = item.featured_image.src;
          }
        }
      }

    });
  }

  function quantity() {
    var qtyIncrement = document.querySelectorAll('.js--quantity');

    qtyIncrement.forEach(function(el) { 
      el.addEventListener("click", updateQty);

      function updateQty(el) {
        var parent = this.closest(".quantity-wrapper"),
            input = parent.querySelector('input'),
            inputVal = parseInt(input.value),
            sendQuantity = 0,
            incrementBoolean = this.getAttribute('data-increment'),
            increment = incrementBoolean.toString();

        if (increment == 'true') {
          var newVal = inputVal+1;
          input.value = newVal;
          //alert('1');
        } else {
          if (inputVal-1 != 0) {
            var newVal = inputVal-1;
            input.value = newVal;
            //alert('2');
          }
        }   
      }
    });
  }

  /**
 * Set loading state.
 */
  function setLoadingState() {
    // If a loading state is needed 🤷‍♀️
    nodeSelectors.body.innerHTML = `<div class="quick-view__loading">Loading</div>`;
    nodeSelectors.body.classList.add('is-loading');
  }

  /**
 * Remove loading state.
 */
  function removeLoadingState() {
    // If a loading state is needed 🤷‍♀️
    nodeSelectors.body.classList.remove('is-loading');
    return;
  }

  /**
 * Get quick view product template url.
 * @param {String} handle - The product handle to quick view.
 * @returns {String}
 */
  function getProductUrl(handle) {
    return `/products/${handle}?view=quick-view`;
  }

  /**
 * Expose public interface.
 */
  return init()
})();


/**
 * Component: Product 'you might also like...' Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a product related slider.
 */
theme.productRelatedSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🧑‍🚀 Related Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const swiper = new Swiper('.collection-recommended-swiper', {
      slidesPerView: 1.5,
      spaceBetween: 15,
      breakpoints: {
        300: {
          enabled: true,
          slidesPerView: 1.5,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Create a Cross Sell slider.
 */
theme.crossSellSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🧑‍🚀 Cross Sell Slider: Loaded`)
    let xsellInterval = setInterval(function(){
      if(typeof $ !== 'undefined' && $(".cross-sell li").length > 1){
        createSwiper();
        clearInterval(xsellInterval);
      }
    },300)
  }

  function createSwiper() {
    const swiper = new Swiper('.crosssell-swiper', {
      slidesPerView: 1.5,
      spaceBetween: 15,
      breakpoints: {
        300: {
          enabled: true,
          slidesPerView: 1.5,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
          spaceBetween: 15,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Homepage 'Collection' Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a collection slider.
 */
theme.homeCollectionSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🛁 Collection Slider: Loaded`)
    const sliders = document.querySelectorAll('.collection-swiper');

    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    const sectionId = element.dataset.sectionId;
    const swiper = new Swiper(`.collection-swiper--${sectionId}`, {
      slidesPerView: 4,
      spaceBetween: 35,
      breakpoints: {
        300: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1030: {
          slidesPerView: 4,
        }
      },
      loop: false,
      navigation: {
        nextEl: `.swiper-button-next--${sectionId}`,
        prevEl: `.swiper-button-prev--${sectionId}`,
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;

})();



/**
 * Component: subcategories Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a subcategories slider.
 */
theme.subcategoriesSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🍭 Subcategories Slider: Loaded`)
    const sliders = document.querySelectorAll('.collection-header__subcategories');

    sliders.forEach(element => {
      checkSliderOverflow(element);
      //createSwiper(element);
    });
  }

  function checkSliderOverflow(element){
    var a = element.querySelector(".swiper-wrapper");
    var b = element.querySelector(".swiper-wrapper .swiper-slide");
    var bWidth = b.offsetWidth;
    var count = a.childElementCount;
    var c = count * bWidth;
    var body = document.querySelector("body");

    if (c > body.offsetWidth) {
      //alert('is overflowing');
      body.classList.add("slider-is-overflowing");
      createSwiper(element);
    } else {
      //alert('is not overflowing');
      body.classList.remove("slider-is-overflowing");
      return;
    }
  }

  function createSwiper(element) {
    // const sectionId = element.dataset.sectionId;
    const swiper = new Swiper(`.collection-header__subcategories`, {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      navigation: {
        nextEl: `.swiper-button-next--subcategories`,
        prevEl: `.swiper-button-prev--subcategories`,
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Create a subcategories slider.
 */
theme.quickLinksSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🍭 Quicklinks Slider: Loaded`)
    const sliders = document.querySelectorAll('.quick-links');

    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    // const sectionId = element.dataset.sectionId;
    const swiper = new Swiper(`.quick-links`, {
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: `.swiper-button-next--subcategories`,
        prevEl: `.swiper-button-prev--subcategories`,
      },
      breakpoints: {
        300: {
          enabled: true,
          loop: true,
        },
        990: {
          enabled: false,
          loop: false
        },
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Component: Collection swatches
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a collection swatches.
 */
theme.collectionSwatches = (function() {
  /**
  * Initialise component.
  */
  function init() {
    console.log(`🖌️ Collection Swatches: Loaded`);

    createSwipers();
    toggleTabs();
  }

  function createSwipers() {
    const sliders = document.querySelectorAll('.collection-swatches');

    sliders.forEach(element => {
      newSwiper(element);
    });
  }

  function destroySwipers() {
    const swiper = document.querySelector('.collection-swatches').swiper;

    swiper.destroy();
    console.log(`💣 Swiper: Destroyed`)
  }

  function newSwiper(element) {
    const sectionId = element.dataset.sectionId;
    const swatchCount = parseInt(element.dataset.swatchCount);

    let loopBoo = false;

    if (swatchCount >= 4 ) {
      loopBoo = true;
    }

    const swiper = new Swiper(`.collection-swatches--${sectionId}`, {
      slidesPerView: 4.5,
      spaceBetween: 15,
      breakpoints: {
        300: {
          slidesPerView: 1.5,
        },
        680: {
          slidesPerView: 3,
        },
        990: {
          slidesPerView: 4,
        },
        1030: {
          slidesPerView: 4.5,
        }
      },
      loop: loopBoo,
      navigation: {
        nextEl: `.swiper-button-next--${sectionId}`,
        prevEl: `.swiper-button-prev--${sectionId}`,
      },
    });
  }

  function toggleTabs() {
    const buttons = document.querySelectorAll('.mbs-item-tabs__button');

    buttons.forEach(item => {
      item.addEventListener('click', function(evt){
        removeActiveStateButton(buttons);
        item.classList.add('is-active');

        hideSliders();
        document.querySelector(`.${item.dataset.toggle}`).classList.remove('is-hidden');
        destroySwipers();
        createSwipers();
      })
    });
  }

  function hideSliders() {
    const sliders = document.querySelectorAll('.collection-swatches');

    sliders.forEach(item => {
      item.classList.add('is-hidden');
    });
  }

  function removeActiveStateButton(buttons) {
    buttons.forEach(item => {
      item.classList.remove('is-active');
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });
})();


/**
 * Component: Collection Layout
 * ------------------------------------------------------------------------------
 *
 */

/**
 * Collection layout switcher.
 */
theme.collectionLayout = (function() {
  /**
  * Initialise component.
  */
  function init() {
    console.log(`🏗️ Collection Layout: Loaded`);
    const layout = localStorage.getItem('layout');
    addEventListeners();
    toggleLayout(layout);
  }

  function addEventListeners() {
    const buttons = document.querySelectorAll('.collection-layout-button');

    buttons.forEach(item => {
      item.addEventListener('click', function() {
        removeActiveState(buttons);
        item.classList.add('is-active');

        if(item.classList.contains('collection-layout-button--large')) {
          localStorage.setItem('layout', 'large');
          toggleLayout('large');
        } else {
          localStorage.setItem('layout', 'small');
          toggleLayout('small');
        }
      })
    });
  }

  function toggleLayout(size) {
    const layout = document.querySelector('.collection-layout-container');

    if (!layout) { return }

    if (size === 'large') {
      layout.classList.add('collection-layout-container--large')
    } else {
      layout.classList.remove('collection-layout-container--large')
    }
  }

  function removeActiveState(buttons) {
    buttons.forEach(item => {
      item.classList.remove('is-active');
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });
})();



/**
 * Create a main product slider.
 */
theme.productMainSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🤖 Product Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const container = document.querySelector('.product-main-swiper')

    if (!container) { return }

    const swiper = new Swiper('.product-main-swiper', {
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      autoHeight: true, //enable auto height
      navigation: {
        nextEl: ".swiper-button-next--product-main",
        prevEl: ".swiper-button-prev--product-main",
      },
      on: {
        afterInit: function () {
          setTimeout(() => {
            createVideo();
          }, 1000);
        },
      },
    });
  }

  function createVideo() {
    var productMediaTypeVideo = document.querySelectorAll('[data-product-media-type-video]');

    productMediaTypeVideo.forEach(function(el) {
      theme.ProductVideo.init(el, 'product-template');
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Component: Module Sixteen Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a subcategories slider.
 */
theme.moduleSixteenSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🍭 Menu List Overflow Slider: Loaded`)
    const sliders = document.querySelectorAll('.module-sixteen__links');

    sliders.forEach(element => {
      checkSliderOverflow(element);
    });
  }

  function checkSliderOverflow(element){
    var a = element.querySelector("ul");
    var b = element.querySelector("ul li");
    var bWidth = b.offsetWidth;
    var count = a.childElementCount;
    var c = count * bWidth;
    var body = document.querySelector("body");

    if (c > body.offsetWidth) {
      //alert('is overflowing');
      body.classList.add("slider-is-overflowing");
      createSwiper(element);
    } else {
      //alert('is not overflowing');
      body.classList.remove("slider-is-overflowing");
      return;
    }
  }

  function createSwiper(element) {
    // const sectionId = element.dataset.sectionId;
    const swiper = new Swiper(`.module-sixteen__links`, {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: true,
      navigation: {
        nextEl: `.swiper-button-next--subcategories`,
        prevEl: `.swiper-button-prev--subcategories`,
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;

  function checkOverflow(){
    var header = document.querySelectorAll('.module-sixteen__links');
    var nav = document.querySelectorAll('.module-sixteen__links-container');
    var container = document.querySelector("body");

    if (nav.offsetWidth > header.offsetWidth) {
      container.classList.add("is-overflowing");

      var underlay = document.querySelector(".drawer-page-content");
      var divsToHide = document.getElementsByClassName("meganav");
      var d = document.getElementsByClassName("site-nav__link");

      for(var i = 0; i < divsToHide.length; i++){
        divsToHide[i].classList.remove("is-visible");
      }

      for(var i = 0; i < d.length; i++){
        d[i].classList.remove("active-link");
      }
    } else {
      container.classList.remove("is-overflowing");
      meganav();
    }
  }

  window.addEventListener("load", checkOverflow);
  window.addEventListener("resize", checkOverflow);
})();


/**
 * Component: Module Nine Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.moduleNineSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Module Nine Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const swiper = new Swiper('.module-nine-swiper', {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 45,
      loop: false,
      breakpoints: {
        300: {
          enabled: true,
          slidesPerView: 1.5,
          centeredSlides: true,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 45,
          loop: false,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  window.addEventListener('resize', () => {
    init();
  });

  return init;
})();

/**
 * Create article excerpt slider.
 */
theme.articleExcerptSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🍭 Article Excerpt Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const container = document.querySelectorAll('.article-excerpt__swiper');

    if (!container) { return }

    const swiper = new Swiper(`.article-excerpt__swiper`, {
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      navigation: {
        nextEl: `.swiper-button-next--article`,
        prevEl: `.swiper-button-prev--article`,
      },
    });
    console.log('click');
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Table respond on click mobile
 * ------------------------------------------------------------------------------
 * A table component.
 *
 */

/**
 * Create a responsive table.
 */
 theme.tableJS = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🤠 Table JS: Loaded`)
    addEventListeners();
  }

  function addEventListeners(){
    const tables = document.querySelectorAll('.table-js');

    tables.forEach(item => {
      checkTables(item);
    })

    document.addEventListener('click', function (event) {
      const element = event.target;

      if (element.matches('.table-js-arrow.table-js-arrow--next')) {
        const tableContainer = element.parentNode.querySelector('.table-js__container');
        tableContainer.scrollLeft += 80;
      }

      if (element.matches('.table-js-arrow.table-js-arrow--prev')) {
        const tableContainer = element.parentNode.querySelector('.table-js__container');
        tableContainer.scrollLeft -= 80;
      }
    });
  }

  function checkTables(item) {
    const table = item.querySelector('table')
    if (!table) { return }
    const cellCount = table.rows[0].cells.length;

    if (cellCount >= 4 ) {
      createTable(item);
    }
  }

  function createTable(item) {
    addActiveClass(item);
    createArrow(item);
    setTimeout(() => {
      showArrow(item)
    }, 1000); //300

    window.addEventListener('resize', function(){
      showArrow(item);
    });

    const tableContainer = item.querySelector('.table-js__container');
    tableContainer.addEventListener("scroll", function () {
      checkArrowActive(tableContainer)
    });
  }

  function addActiveClass(item) {
    item.classList.add('is-active');
  }

  function createArrow(item) {
    item.insertAdjacentHTML('beforeend', '<div class="table-js-arrow table-js-arrow--next"></div><div class="swiper-button__underlay swiper-button__underlay--next"></div>');
    item.insertAdjacentHTML('beforeend', '<div class="table-js-arrow table-js-arrow--prev"></div><div class="swiper-button__underlay swiper-button__underlay--prev"></div>');
  }

  function showArrow(item) {
    const containerWidth = item.offsetWidth;
    const tableWidth = item.querySelector('table').offsetWidth;

    if (tableWidth > containerWidth) {
      item.querySelector('.table-js-arrow--next').classList.add('is-active');
      item.querySelector('.swiper-button__underlay--next').classList.add('is-active');
    } else {
      item.querySelector('.table-js-arrow--next').classList.remove('is-active');
      item.querySelector('.swiper-button__underlay--next').classList.remove('is-active');
    }
  }

  function checkArrowActive(table) {
    setTimeout(() => {
      const scrollMax = table.scrollWidth - table.clientWidth;;
      const next = table.parentNode.querySelector('.table-js-arrow--next');
      const nextUnderLay = table.parentNode.querySelector('.swiper-button__underlay--next');
      const prev = table.parentNode.querySelector('.table-js-arrow--prev');
      // const prevUnderLay = table.parentNode.querySelector('.swiper-button__underlay--prev');

      if (scrollMax === table.scrollLeft) {
        next.classList.remove('is-active');
        nextUnderLay.classList.remove('is-active');
      } else {
        next.classList.add('is-active');
        nextUnderLay.classList.add('is-active');
      }

      if (0 === table.scrollLeft) {
        prev.classList.remove('is-active');
        // prevUnderLay.classList.remove('is-active');
      } else {
        prev.classList.add('is-active');
        // prevUnderLay.classList.add('is-active');
      }
    }, 500);
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();



/**
 * Component: Wallpaper Calculator
 * ------------------------------------------------------------------------------
 *
 */

// 33 inches is 2.75 feet
// 1 yard is 3 feet

// 1 roll is 2.75 feet wide by 3 feet long
// 1 roll covers 90.75 square feet

function calculateRollsNeeded(width, height) {
  const rollWidth = 2.75; // feet
  const rollLength = 3; // feet

  const rollCoverage = rollWidth * rollLength; // square feet

  const totalArea = width * height; // square feet
  let rollsNeeded = (totalArea / rollCoverage);
  rollsNeeded *= 1.3; // Add 30% for waste

  return Math.ceil(rollsNeeded);
}

class WallpaperCalculator extends HTMLElement {
  constructor() {
    super();

    // Set up initial values
    this.width = 0;
    this.height = 0;
    this.unit = 'feet';
    this.variantId = this.dataset.variantId;
    // Attach event listeners
    this.querySelector('#widthInput').addEventListener('input', this.handleInput.bind(this));
    this.querySelector('#heightInput').addEventListener('input', this.handleInput.bind(this));
    this.querySelector('.wallpaper-atc').addEventListener('click', this.handleAddToCart.bind(this));
    document.querySelector('.wallpaper-popup__button').addEventListener('click', this.handlePopupOpen.bind(this));
    this.querySelector('.wallpaper-overlay').addEventListener('click', this.handlePopupClose.bind(this));
    this.querySelector('.wallpaper-close').addEventListener('click', this.handlePopupClose.bind(this));
    document.querySelector('.product-template__container').addEventListener('variantChange', this.handleVariantChange);
  }

  handleInput() {
    // Update width and height values
    this.width = parseFloat(this.querySelector('#widthInput').value) || 0;
    this.height = parseFloat(this.querySelector('#heightInput').value) || 0;
    // Update the result
    this.updateResult();
  }

  handleUnitChange() {
    // Update unit value
    this.unit = this.querySelector('#unitSelector').value;

    // Update the result
    this.updateResult();
  }

  handlePopupOpen() {
    this.querySelector('.wallpaper-popup').classList.add('is-active');
  }

  handlePopupClose() {
    this.querySelector('.wallpaper-popup').classList.remove('is-active');
  }

  async handleAddToCart() {
    // Get the quantity value
    let params = (new URL(document.location)).searchParams;
    let variantId = params.get("variant") || this.dataset.variantId;
    const quantity = this.rollCount;
    this.querySelector('[data-add-to-cart-text]').classList.add('hide');
    this.querySelector('[data-loader]').classList.remove('hide');
    
    let resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });
    let data = await resp.json();

    this.querySelector('[data-add-to-cart-text]').classList.remove('hide');
    this.querySelector('[data-loader]').classList.add('hide');
    this.handlePopupClose();
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        item: data,
        quantity: quantity
      }
    }));
  }

  handleVariantChange(e) {
    this.dataset.variantId = e.detail.variant.id;
    this.dataset.variantPrice = e.detail.variant.price;
    this.querySelector('.wallpaper-price').innerHTML = theme.Currency.formatMoney(e.detail.variant.price * this.rollCount, theme.moneyFormat)
  }

  updateResult() {
    // Calculate the number of rolls needed
    let rollsNeeded = calculateRollsNeeded(this.width, this.height);
    // Update the result text
    this.querySelector('.wallpaper-result').innerHTML = `
      ${rollsNeeded} yards needed
      ${rollsNeeded < 5 ? `<p class="form-message--error">Minimum order quantity is 5 yards</p>` : ``}
    `;
    this.rollCount = rollsNeeded;

    let price = this.dataset.variantPrice * rollsNeeded;
    this.querySelector('.wallpaper-price').innerHTML = theme.Currency.formatMoney(price, theme.moneyFormat);
    if (rollsNeeded < 5) {
      rollsNeeded = 5;
    }
    //document.querySelector('.product-form__input--quantity').value = rollsNeeded;
    this.querySelector('#wallpaper-quantity').value = rollsNeeded;
    
    //document.querySelector('.product-form__input--quantity').dispatchEvent(new Event('change'));
    this.querySelector('#wallpaper-quantity').dispatchEvent(new Event('change'));
  }
}

// Define the custom element
customElements.define('wallpaper-calculator', WallpaperCalculator);

class SampleDrawer extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.drawer = this.querySelector('.product-single__drawer');
    this.requestButton = document.querySelector('.swatch-trigger');
    this.sampleButtons = this.querySelectorAll('.product-single__drawer-item__button');
    this.closeButton = this.querySelector('.product-single__drawer-close');
    this.tabLinks = this.querySelectorAll('.product-single__drawer-tab');

    this.container.addEventListener('click', (e) => {
      if (e.target === this.container) {
        this.close();
      }
    });
    this.requestButton.addEventListener('click', this.open.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.sampleButtons.forEach((button) => {
      button.addEventListener('click', this.addToCart.bind(this, button));
    });
    this.tabLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        let tab = link.dataset.id;
        let target = this.querySelector(`.product-single__drawer-collection[data-id="${tab}"]`);
        this.drawer.scrollTo({
          top: target.offsetTop - 20,
          behavior: 'smooth'
        });
      });
    });
  }

  open() {
    this.container.classList.add('product-single__drawer--open');
    document.body.classList.add('no-scroll');
  }

  close() {
    this.container.classList.remove('product-single__drawer--open');
    document.body.classList.remove('no-scroll');
  }

  async addToCart(button) {
    const variantId = button.closest('.product-single__drawer-item').dataset.id;
    const quantity = 1;
    
    button.querySelector('[data-add-to-cart-text]').classList.add('hide');
    button.querySelector('[data-loader]').classList.remove('hide');

    let resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    });
    let data = await resp.json();
    
    button.querySelector('[data-add-to-cart-text]').classList.remove('hide');
    button.querySelector('[data-loader]').classList.add('hide');

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        item: data,
        quantity: quantity
      }
    }));
  }
}

customElements.define('sample-drawer', SampleDrawer);

document.addEventListener('DOMContentLoaded', () => {
  let swatchTrigger = document.querySelector('.swatch-trigger');

  if (swatchTrigger && swatchTrigger.dataset.single) {
    swatchTrigger.addEventListener('click', () => {
      swatchTrigger.querySelector('[data-add-to-cart-text]').classList.add('hide');
      swatchTrigger.querySelector('[data-loader]').classList.remove('hide');
      fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: swatchTrigger.dataset.single,
          quantity: 1
        })
      }).then((res) => {
        return res.json();
      }).then((data) => {
        swatchTrigger.querySelector('[data-add-to-cart-text]').classList.remove('hide');
        swatchTrigger.querySelector('[data-loader]').classList.add('hide');
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            item: data,
            quantity: 1
          }
        }));
      });
    });
  }

  let fabricDropdowns = document.querySelectorAll('.product-single__drawer-item__info');
  fabricDropdowns.forEach((dropdownButton) => {
    dropdownButton.addEventListener('click', (e) => {
      if (!e.target.classList.contains('product-single__drawer-item__info')) {
        return;
      }
      let dropdown = dropdownButton.querySelector('.product-single__drawer-item__info-dropdown');
      dropdown.classList.toggle('is-active');
      dropdownButton.classList.toggle('is-active');
    });
  });

  let careDetailsTriggers = document.querySelectorAll('span[data-care-details]');
  let careDetailsDrawer = document.querySelector('.care-details');
  careDetailsTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      careDetailsDrawer.classList.toggle('care-details--active');
    });
  });

  let careDetailsClose = document.querySelector('.care-details__close');
  careDetailsClose.addEventListener('click', () => {
    careDetailsDrawer.classList.remove('care-details--active');
  });
});